var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"menu has-background-light",attrs:{"id":"comments-side-bar"}},[_c('p',{staticClass:"subtitle is-size-4"},[_c('span',{staticClass:"icon",on:{"click":function($event){return _vm.$store.commit('app/closeRightAside')}}},[_c('i',{staticClass:"fa fa-caret-right"})]),_vm._v(" Version History ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }